module.exports = __webpack_public_path__ + "static/media/succespass.db888be8.svg";